import * as React from 'react';
import { Panel, Alert } from '@ixicare/ui';
import { t } from '~/i18n';
import { formatDateTimeWritten } from '@ixicare/ui';
import MapWithInfo from '~/components/MapWithInfo';
import { observer } from 'mobx-react';
import { useStores } from '~store/utils';
import PositionMap from '~containers/PositionMap';
import { useGPSGeofence, useLocation } from '~hooks/location';

const ResidentLocationMap: React.FC = () => {
  const { residentDetail } = useStores();

  const device = residentDetail.profile?.ownedDevice;
  const locationData = useLocation(device?.id);
  const geo = useGPSGeofence(residentDetail.profile?.id);

  return (
    <Panel.Section>
      <Panel.Title extraInfo={locationData?.timestamp ? formatDateTimeWritten(locationData.timestamp) : ''}>
        {t('residentDetail.location.currentLocation')}
      </Panel.Title>
      {device ? (
        <MapWithInfo info={locationData?.description}>
          <PositionMap isStatic={device.locationIsStatic} locationData={locationData} geofence={geo} />
        </MapWithInfo>
      ) : (
        <Alert type="message">{t('residentDetail.location.noLocation')}</Alert>
      )}
    </Panel.Section>
  );
};

export default observer(ResidentLocationMap);
